import {getUserApiData} from "../../utils/UserUtils";
import {invokeApig} from "../../libs/awsLib";
import Paths from "../paths";
import {myID} from "../../libs/generateID";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";
import {
    createSuccessNotification,
    createErrorNotification,
} from "../../utils/ResponseUtils";

export function createP2(data, {FarmID, ClientID, LocalUserID} = {}) {
    const {_FarmID, _LocalUserID, _ClientID} = getUserApiData({
        FarmID,
        ClientID,
        LocalUserID,
    });
    return invokeApig({
        ...Paths.createP2({
            farmID: _FarmID,
            clientID: _ClientID,
            localUserID: _LocalUserID,
        }),
        body: data,
    });
}

export function createP2NotificationSuccess(
    response,
    {uniqueId = myID()} = {}
) {
    if (createSuccessNotification(response, "fatMeasurement")) return;
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("fatMeasurement"),
            message: i18n.t("apiNotifications.createP2Success"),
            status: "success",
            dismissible: true,
            dismissAfter: 5000,
        })
    );
}

export function createP2NotificationFailure(
    response,
    {uniqueId = myID()} = {}
) {
    if (
        createErrorNotification(response, "fatMeasurement", {
            uniqueId,
        })
    )
        return;
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("fatMeasurement"),
            message: i18n.t("apiNotifications.createP2Failure"),
            status: "error",
            dismissible: true,
            // buttons: checkLogsButton(),
            dismissAfter: 15000,
        })
    );
}
